import FollowersWidget from './FollowersWidget'

export default FollowersWidget
